import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const StreakCheckIcon = ({ classObject }) => {
    return React.createElement("img", { src: "/assets/images/icons/streak_check.svg", className: css(styles.icon, classObject) });
};
const styles = StyleSheet.create({
    icon: {
        width: 46,
        height: 46,
    },
});
